import { __awaiter } from "tslib";
/* eslint-disable @typescript-eslint/naming-convention */
import { get, isNumber, isString } from 'lodash';
import useHttp from './use-http';
import { MANUAL_STAT_POST_TYPE_FIELD_MAP, MANUAL_STAT_FIELD_LABEL_MAP, CONTENT_TYPE_STORY, CONTENT_TYPE_POST, CONTENT_TYPE_REEL } from '../../app-v2/constants/activation-content-metrics';
import { getContentMetricScreenshotFilePaths } from '../../app-v2/helpers/activations/activation-files';
const useContentMetrics = () => {
    const { http } = useHttp();
    const getMetricFieldLabel = (fieldName) => {
        const label = get(MANUAL_STAT_FIELD_LABEL_MAP, fieldName);
        if (!label || !isString(label)) {
            return '';
        }
        return label;
    };
    const getMetricFieldValue = (fieldName, input) => {
        let value = get(input, fieldName, input);
        if (isString(value)) {
            value = parseInt(value);
        }
        if (!value || !isNumber(value)) {
            return null;
        }
        return value;
    };
    const setMetricFieldValue = (fieldName, input, value) => {
        return Object.assign(Object.assign({}, input), { [fieldName]: value });
    };
    const getMetricRealFieldValue = (fieldName, content, defaultValue = 0) => {
        let value = get(content, `stat.${fieldName}_real`);
        if (isString(value)) {
            value = parseInt(value);
        }
        if (!value || !isNumber(value)) {
            return defaultValue;
        }
        return value;
    };
    const hasMetricRealFieldValue = (fieldName, content) => {
        return getMetricRealFieldValue(fieldName, content) > 0;
    };
    const getContentType = (content) => {
        const isReel = get(content, 'is_reel');
        const isStory = get(content, 'is_story');
        return isReel ? CONTENT_TYPE_REEL : isStory ? CONTENT_TYPE_STORY : CONTENT_TYPE_POST;
    };
    const getManualStatFields = (content) => {
        const fields = get(MANUAL_STAT_POST_TYPE_FIELD_MAP.find((map) => map.type === getContentType(content)), 'fields');
        if (!fields) {
            return [];
        }
        return fields;
    };
    const setManualStatInput = (content, input) => {
        return getManualStatFields(content).reduce((acc, key) => {
            const inputValue = get(input, key);
            const existingValue = get(content, `stat.manual_${key}`, 0);
            if (isNumber(inputValue) && inputValue > 0) {
                acc[key] = inputValue;
            }
            else if (isNumber(existingValue) && existingValue > 0) {
                acc[key] = existingValue;
            }
            else {
                acc[key] = null;
            }
            return acc;
        }, {});
    };
    const getContentByIdAndContactId = (id, contactId) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield http.get(`/contact/${contactId}/content/${id}`);
        return (response === null || response === void 0 ? void 0 : response.body) || null;
    });
    const updateContentMetrics = (id, contactId, input) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield http.post(`/contact/${contactId}/content/${id}/update-manual-stats`, input);
        return (response === null || response === void 0 ? void 0 : response.body) || null;
    });
    const getScreenshotFilesWithUrls = (contentId, contact, files) => {
        return getContentMetricScreenshotFilePaths(files, `${contact.account_id}/${contact.id}/${contentId}/`);
    };
    const postScreenshots = (contentId, contactId, payload) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/contact/${contactId}/content/${contentId}/content-metric-screenshots`;
        const response = yield http.post(url, payload);
        return (response === null || response === void 0 ? void 0 : response.body) || null;
    });
    const deleteScreenshotFile = (contentId, contactId, fileName) => __awaiter(void 0, void 0, void 0, function* () {
        const url = `/contact/${contactId}/content/${contentId}/content-metric-screenshot/${fileName}/delete`;
        const response = yield http.delete(url);
        return (response === null || response === void 0 ? void 0 : response.body) || null;
    });
    return {
        getMetricFieldLabel,
        getMetricFieldValue,
        setMetricFieldValue,
        getMetricRealFieldValue,
        hasMetricRealFieldValue,
        getContentType,
        getManualStatFields,
        setManualStatInput,
        getContentByIdAndContactId,
        updateContentMetrics,
        getScreenshotFilesWithUrls,
        postScreenshots,
        deleteScreenshotFile
    };
};
export default useContentMetrics;
